import { Component } from '@angular/core';
import { GridFilterBase } from '../grid-filter-base/grid-filter-base';

@Component({
    selector: 'spv2-grid-efile-submission-status-filter',
    templateUrl: './grid-efile-submission-status-filter.component.html',
    styleUrls: ['./grid-efile-submission-status-filter.component.scss'],
    standalone: false
})
export class GridEfileSubmissionStatusFilterComponent extends GridFilterBase<string[]> {

}
